(function(){
var d = document;
function J(id){ var e = d.getElementById(id); try { return JSON.parse(e.textContent); } catch(x) { return {}; } }
d.querySelectorAll('[data-rp-buy]').forEach(function(b){ b.addEventListener('click', function(){ var f = d.querySelector('.rp2-hook'); if (f) f.submit(); }); });
var thumbs = d.querySelectorAll('.rp2 .thumb');
thumbs.forEach(function(t){ t.addEventListener('click', function(){
thumbs.forEach(function(x){ x.classList.remove('active'); });
t.classList.add('active');
var img = t.querySelector('img'), main = d.querySelector('#rp2MainImg img');
if (img && main) main.src = img.src;
}); });
function play(){ d.querySelectorAll('.rp2 video.rp-autoplay').forEach(function(v){ v.muted = true; v.setAttribute('muted',''); v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }); }
play();
window.addEventListener('load', play);
['touchstart','click','scroll'].forEach(function(e){ window.addEventListener(e, play, {once:true, passive:true}); });
var els = d.querySelectorAll('.rp2 .reveal');
if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('on'); }); }
else {
var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('on'); io.unobserve(en.target); } }); }, {threshold:.12});
els.forEach(function(el){ io.observe(el); });
}
(function(){
var data = J('rps-toast-data'), buyers = data.buyers || [];
var colors = ['#7E57C2','#E2556F','#2E8BC0','#2BA98E','#E0884F','#9C6ADE','#3B5BA9','#D35D8C','#2F9C95','#C9822F','#7A6FD0','#D2556B','#4C9A5F','#8C6BC8'];
var box = d.getElementById('rp2Toast');
if (!box || !buyers.length) return;
var av = d.getElementById('rp2ToastAv'), nameEl = d.getElementById('rp2ToastName'), msgEl = d.getElementById('rp2ToastMsg');
var bag = [];
function refill(){ bag = buyers.map(function(_, i){ return i; }); for (var i = bag.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = bag[i]; bag[i] = bag[j]; bag[j] = t; } }
function show(){
if (!bag.length) refill();
var k = bag.pop(), b = buyers[k], parts = b.n.split(' ');
av.textContent = (parts[0][0] + (parts[1] ? parts[1][0] : '')).toUpperCase();
av.style.background = colors[k % colors.length];
nameEl.textContent = b.n + ' — ' + b.c;
msgEl.textContent = (data.toast || 'Hizo su pedido') + ' · hace ' + (1 + Math.floor(Math.random() * 14)) + ' min';
box.classList.add('show');
setTimeout(function(){ box.classList.remove('show'); }, 5000);
}
function next(){ setTimeout(function(){ show(); next(); }, 14000 + Math.random() * 14000); }
setTimeout(function(){ show(); next(); }, 4000);
})();
(function(){
var data = J('rps-chat-data'), qa = data.qa || [];
var greeting = data.greeting || '', fallback = data.fallback || '';
var fb = d.getElementById('rp2ChatBtn'), panel = d.getElementById('rp2ChatPanel'), cb = d.getElementById('rp2ChatClose');
var body = d.getElementById('rp2ChatBody'), quick = d.getElementById('rp2ChatQuick'), form = d.getElementById('rp2ChatForm'), input = d.getElementById('rp2ChatInput');
if (!fb || !panel) return;
var started = false;
function add(html, who){ var el = d.createElement('div'); el.className = 'chat-msg ' + who; el.innerHTML = html; body.appendChild(el); body.scrollTop = body.scrollHeight; }
function chips(){ quick.innerHTML = ''; qa.forEach(function(it){ var c = d.createElement('button'); c.type = 'button'; c.className = 'chat-chip'; c.textContent = it.q; c.addEventListener('click', function(){ ask(it); }); quick.appendChild(c); }); }
function ask(it){ add(it.q, 'user'); setTimeout(function(){ add(it.a, 'bot'); }, 450); }
function match(text){ var n = text.toLowerCase(), best = null, bs = 0; qa.forEach(function(it){ var s = 0; (it.k || []).forEach(function(k){ k = k.trim(); if (k && n.indexOf(k) !== -1) s++; }); if (s > bs){ bs = s; best = it; } }); return best; }
function open(){ panel.classList.add('open'); if (!started){ started = true; add(greeting, 'bot'); chips(); } }
fb.addEventListener('click', function(){ if (panel.classList.contains('open')) panel.classList.remove('open'); else open(); });
cb.addEventListener('click', function(){ panel.classList.remove('open'); });
form.addEventListener('submit', function(e){ e.preventDefault(); var v = input.value.trim(); if (!v) return; add(v.replace(/</g,'&lt;'), 'user'); input.value = ''; var m = match(v); setTimeout(function(){ add(m ? m.a : fallback, 'bot'); }, 450); });
})();
})();